
import {

  Paper,
  Box,
  Typography,
  
  Card,
  CardContent
} from "@mui/material";

const AdjustmentEntry = ({ heading, headingto, journalEntries }) => {
  
  const TableHeader = () => (
    <Box sx={{ 
      display: { xs: 'none', md: 'flex' },
      backgroundColor: '#e3f2fd', 
      borderRadius: '4px 4px 0 0',
      border: '1px solid #dee2e6',
      borderBottom: 'none'
    }}>
      <Box sx={{ 
        flex: '0 0 12%', 
        p: 1.5, 
        textAlign: 'center', 
        fontWeight: 'bold',
        borderRight: '1px solid #dee2e6',
        fontSize: '0.875rem',
        color: '#1976d2'
      }}>
        Date
      </Box>
      <Box sx={{ 
        flex: '1', 
        p: 1.5, 
        textAlign: 'center', 
        fontWeight: 'bold',
        borderRight: '1px solid #dee2e6',
        fontSize: '0.875rem',
        color: '#1976d2'
      }}>
        Particulars
      </Box>
      <Box sx={{ 
        flex: '0 0 8%', 
        p: 1.5, 
        textAlign: 'center', 
        fontWeight: 'bold',
        borderRight: '1px solid #dee2e6',
        fontSize: '0.875rem',
        color: '#1976d2'
      }}>
        LF
      </Box>
      <Box sx={{ 
        flex: '0 0 15%', 
        p: 1.5, 
        textAlign: 'center', 
        fontWeight: 'bold',
        borderRight: '1px solid #dee2e6',
        fontSize: '0.875rem',
        color: '#1976d2'
      }}>
        Dr. Amount
      </Box>
      <Box sx={{ 
        flex: '0 0 15%', 
        p: 1.5, 
        textAlign: 'center', 
        fontWeight: 'bold',
        borderRight: '1px solid #dee2e6',
        fontSize: '0.875rem',
        color: '#1976d2'
      }}>
        Cr. Amount
      </Box>
      <Box sx={{ 
        flex: '1', 
        p: 1.5, 
        textAlign: 'center', 
        fontWeight: 'bold',
        fontSize: '0.875rem',
        color: '#1976d2'
      }}>
        Description
      </Box>
    </Box>
  );

  // Desktop table row
  const TableRow = ({ entry, index }) => (
    <Box sx={{ 
      display: { xs: 'none', md: 'flex' },
      border: '1px solid #dee2e6',
      borderTop: 'none',
      backgroundColor: index % 2 === 0 ? '#fff' : '#fafafa',
      '&:hover': {
        backgroundColor: '#f5f5f5'
      },
      minHeight: '60px',
      alignItems: 'stretch'
    }}>
      <Box sx={{ 
        flex: '0 0 12%',
        p: 1.5, 
        textAlign: 'center',
        borderRight: '1px solid #dee2e6',
        fontSize: '0.875rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        {entry.date || ''}
      </Box>
      <Box sx={{ 
        flex: '1',
        p: 1.5, 
        borderRight: '1px solid #dee2e6',
        fontSize: '0.875rem',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center'
      }}>
        {(heading || entry.debitAccount) && (
          <Box sx={{ mb: 0.5 }}>
            {heading || entry.debitAccount} A/c 
            <Box component="span" sx={{ float: 'right', fontWeight: 'bold' }}>
              Dr
            </Box>
          </Box>
        )}
        {(headingto || entry.creditAccount) && (
          <Box sx={{ 
            textAlign: 'center', 
            fontSize: '0.8rem',
            color: '#666'
          }}>
            To {headingto || entry.creditAccount} A/c
          </Box>
        )}
      </Box>
      <Box sx={{ 
        flex: '0 0 8%',
        p: 1.5, 
        textAlign: 'center',
        borderRight: '1px solid #dee2e6',
        fontSize: '0.875rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        {entry.ledgerFolio || ''}
      </Box>
      <Box sx={{ 
        flex: '0 0 15%',
        p: 1.5, 
        textAlign: 'right',
        borderRight: '1px solid #dee2e6',
        fontSize: '0.875rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        fontWeight: entry.debitAmount ? 'bold' : 'normal'
      }}>
        {entry.debitAmount ? `₹${entry.debitAmount.toLocaleString()}` : ''}
      </Box>
      <Box sx={{ 
        flex: '0 0 15%',
        p: 1.5, 
        textAlign: 'right',
        borderRight: '1px solid #dee2e6',
        fontSize: '0.875rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        fontWeight: entry.creditAmount ? 'bold' : 'normal'
      }}>
        {entry.creditAmount ? `₹${entry.creditAmount.toLocaleString()}` : ''}
      </Box>
      <Box sx={{ 
        flex: '1',
        p: 1.5, 
        fontSize: '0.875rem',
        display: 'flex',
        alignItems: 'center',
        wordBreak: 'break-word'
      }}>
        {entry.description || ''}
      </Box>
    </Box>
  );

  // Mobile card component
  const MobileCard = ({ entry, index }) => (
    <Card 
      sx={{ 
        mb: 2, 
        display: { xs: 'block', md: 'none' },
        boxShadow: 1,
        border: '1px solid #e0e0e0'
      }}
    >
      <CardContent sx={{ p: 2, '&:last-child': { pb: 2 } }}>
 
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          mb: 2,
          flexWrap: 'wrap',
          gap: 1
        }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
            {entry.date || 'No Date'}
          </Typography>
          <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
            {entry.debitAmount && (
              <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#d32f2f' }}>
                Dr: ₹{entry.debitAmount.toLocaleString()}
              </Typography>
            )}
            {entry.creditAmount && (
              <Typography variant="body2" sx={{ fontWeight: 'bold', color: '#2e7d32' }}>
                Cr: ₹{entry.creditAmount.toLocaleString()}
              </Typography>
            )}
          </Box>
        </Box>

       
        <Box sx={{ mb: 2 }}>
          <Typography variant="caption" sx={{ color: '#666', fontWeight: 'bold' }}>
            PARTICULARS
          </Typography>
          <Box sx={{ mt: 0.5 }}>
            {(heading || entry.debitAccount) && (
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                <Box component="span" sx={{ fontWeight: 'bold' }}>
                  {heading || entry.debitAccount} A/c
                </Box>
                <Box component="span" sx={{ float: 'right', fontWeight: 'bold', color: '#d32f2f' }}>
                  Dr
                </Box>
              </Typography>
            )}
            {(headingto || entry.creditAccount) && (
              <Typography variant="body2" sx={{ 
                textAlign: 'center', 
                fontStyle: 'italic',
                color: '#666',
                fontSize: '0.875rem'
              }}>
                To {headingto || entry.creditAccount} A/c
              </Typography>
            )}
          </Box>
        </Box>

       
        <Box sx={{ 
          display: 'flex', 
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          flexWrap: 'wrap',
          gap: 2
        }}>
          {entry.ledgerFolio && (
            <Box>
              <Typography variant="caption" sx={{ color: '#666', fontWeight: 'bold' }}>
                LF
              </Typography>
              <Typography variant="body2">
                {entry.ledgerFolio}
              </Typography>
            </Box>
          )}
          
          {entry.description && (
            <Box sx={{ flex: 1, minWidth: '200px' }}>
              <Typography variant="caption" sx={{ color: '#666', fontWeight: 'bold' }}>
                DESCRIPTION
              </Typography>
              <Typography variant="body2" sx={{ mt: 0.5, wordBreak: 'break-word' }}>
                {entry.description}
              </Typography>
            </Box>
          )}
        </Box>
      </CardContent>
    </Card>
  );


  const EmptyTableRow = () => (
    <Box sx={{ 
      display: { xs: 'none', md: 'flex' },
      border: '1px solid #dee2e6',
      borderTop: 'none',
      backgroundColor: '#fff'
    }}>
      <Box sx={{ 
        width: '100%',
        p: 4, 
        textAlign: 'center',
        color: '#666',
        fontStyle: 'italic',
        fontSize: '1rem'
      }}>
        No adjustment entries to display
      </Box>
    </Box>
  );


  const EmptyMobileCard = () => (
    <Card sx={{ display: { xs: 'block', md: 'none' }, boxShadow: 1 }}>
      <CardContent sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="body1" sx={{ color: '#666', fontStyle: 'italic' }}>
          No adjustment entries to display
        </Typography>
      </CardContent>
    </Card>
  );

  return (
    <Box sx={{ width: '100%', mb: 3 }}>
      <Typography 
        variant="h6" 
        sx={{ 
          mb: 2, 
          fontWeight: 'bold',
          fontSize: { xs: '1.1rem', md: '1.25rem' }
        }}
      >
        Adjustment Entries
      </Typography>
      
     
      <Paper 
        elevation={1}
        sx={{
          width: '100%',
          overflow: 'hidden',
          border: '1px solid #dee2e6',
          display: { xs: 'none', md: 'block' }
        }}
      >
        <TableHeader />
        {journalEntries && journalEntries.length > 0 ? (
          journalEntries.map((entry, index) => (
            <TableRow key={index} entry={entry} index={index} />
          ))
        ) : (
          <EmptyTableRow />
        )}
      </Paper>

     
      <Box sx={{ display: { xs: 'block', md: 'none' } }}>
        {journalEntries && journalEntries.length > 0 ? (
          journalEntries.map((entry, index) => (
            <MobileCard key={`mobile-${index}`} entry={entry} index={index} />
          ))
        ) : (
          <EmptyMobileCard />
        )}
      </Box>
    </Box>
  );
};

export default AdjustmentEntry;
